<template>
  <div>
    <div class="ui styled attached accordion" style="width: 100%" v-if="currentImages.length">
      <div 
        v-for="(date, arrIndex) in Object.keys(currentImagesGroupedByDate)"
        :key="arrIndex"
      >
        <div 
          class="title"
          :class="{active: currentDate === date}"
          @click="toggleActive(date)"
        >
          <i class="dropdown icon"></i>
          {{ timeFormat(date) }}
        </div>
        <div 
          class="content"
          :class="{ active:  currentDate === date}"
        >
          <div class="ui four column center aligned grid" style="margin-bottom: 10px;">
            <div 
              class="column" 
              v-for="(image, imageIndex) in currentImagesGroupedByDate[date]" 
              :key="imageIndex"
              @click="index = imageIndex"
            >
              <img 
                :src="image.picture.url" 
                class="ui image" 
                style="height: 250px; object-fit: contain; margin-right: 8px; cursor: pointer"
              />
            </div>
          </div>
          <vue-gallery-slideshow 
            :images="getImagesUrls()" 
            :index="index" 
            @close="index = null" 
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No images have been uploaded yet
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallerySlideshow from 'vue-gallery-slideshow';
export default {
  components: {
    imageComponent: require('@/components/abstract_components/Image').default,
    VueGallerySlideshow
  },
  props: {
    imagesProp: { type: Array, default: () => [] }
  },
  watch: {
    imagesProp: {
      handler: function () {
        this.setCurrentImages()
        this.setImagesByDate()
      },
      deep: true
    }
  },
  mounted () {
    this.setCurrentImages()
    this.setImagesByDate()
  },
  data () {
    return {
      currentImages: [],
      currentImagesGroupedByDate: {},
      currentDate: null,
      index: null
    }
  },
  methods: {
    timeFormat (time) {
      return window.moment(time).format('LL')
    },
    setCurrentImages () {
      this.currentImages = this.imagesProp && this.imagesProp.length ? 
        this.imagesProp : []
    },
    setImagesByDate(){
      this.currentImagesGroupedByDate = this.currentImages.reduce((groups, image) => {
        const dayDate = image.created_at.split('T')[0]
        if (!groups[dayDate]) groups[dayDate] = []
        groups[dayDate].push(image)
        return groups
      }, {})
    },
    images() {
      return this.currentImages.length ?
        this.currentImages.map(image => image.picture.url) : []
    },
    getImagesUrls() {
      const images = this.currentImagesGroupedByDate[this.currentDate]
      return images ? images.map(image => image.picture.url) : []
    },
    toggleActive(date) {
      this.currentDate = this.currentDate != date ? date : null
    }
  }
}
</script>

<style scoped>
  .image-size {
    height: 50px !important;
    object-fit: contain;
  }
</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/medical_history_components/Images.vue